import { useMemo } from 'react'
import { BuyDownloadButtonCSV, BuyDownloadButtonPDF, BuyDownloadPdfTemplateButton, BuyDownloadTags, BuyPdfPreview, BuySupplierPdfPreview } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderBuyLayout/BuyButtons'
import { OrderDivideIntoChaptersButton, OrderProductTypesButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { BuyOrderDuplicateButton } from '../../../../BuyOrderButtons'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'

const BuyOrderCreateNoPermissionButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useBuyOrderCreateNoPermissionButtonsLogic, ...rest }} className='mr-8' />
    )
}

const useBuyOrderCreateNoPermissionButtonsLogic = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'buy_order_create_no_permission_step_buttons'
    const Order = data?.header
    const showButtonByPricesPermission = !data?.header?.hidePrices

    const defaultButtons = [{ "id": "downloadPreviewTemplate" }, { "id": "downloadBuy" }, { "id": "duplicateBuyOrder" }]

    const buyOrderDuplicateText = t('duplicateBuyOrder', 'Duplicar pedido de compra')
    const buyOrderDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const buyOrderDownloadTagsText = t('printTags', 'Imprimir etiquetas')
    const buyOrderPreviewPDFText = t('previewPdfTemplate', 'Previsualizar plantilla PDF')
    const buyOrderDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const buyOrderDownloadPDFText = t('downloadPdf', 'Descargar PDF')
    const buyOrderDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const buyOrderProductTypesText = t('valueProductTypes', 'Valor tipos de producto')
    const buyOrderPreviewSupplierPDFText = t('previewSupplierPDF', 'Previsualizar PDF proveedor')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            duplicateBuyOrder: {
                component: BuyOrderDuplicateButton,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyOrderDuplicateText,
                    id: 'duplicateBuyOrder',
                    allRowData: data,
                    permissionTy: 'buy.order',
                }
            },
            downloadBuyCsv: {
                component: BuyDownloadButtonCSV,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyOrderDownloadCSVText,
                    id: 'downloadBuyCsv',
                    Order,
                    typeTemplate: 'buyOrder'
                }
            },
            downloadBuyTag: {
                component: BuyDownloadTags,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyOrderDownloadTagsText,
                    id: 'downloadBuyTag',
                    Order,
                    typeTemplate: 'buyOrder'
                }
            },
            previewBuySupplierPDF: {
                component: BuySupplierPdfPreview,
                showButton: Order.supplierPdf?.length,
                extraProps: {
                    title: buyOrderPreviewSupplierPDFText,
                    id: 'previewBuyOrderPDFSupplier',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'previewBuyOrderPDFSupplier'
                }
            },
            downloadPreviewTemplate: {
                component: BuyPdfPreview,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyOrderPreviewPDFText,
                    id: 'downloadPreviewTemplate',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'downloadPreviewPDFTemplate'
                }
            },
            downloadBuyTemplate: {
                component: BuyDownloadPdfTemplateButton,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyOrderDownloadPDFTemplateText,
                    id: 'downloadBuyTemplate',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'downloadBuyPDFTemplate'
                }
            },
            downloadBuy: {
                component: BuyDownloadButtonPDF,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyOrderDownloadPDFText,
                    id: 'downloadBuy',
                    Order,
                    typeTemplate: 'buyOrder',
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: buyOrderDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
            buyProductTypes: {
                component: OrderProductTypesButton,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyOrderProductTypesText,
                    id: 'buyProductTypes',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [Order, buyOrderDivideIntoChaptersText, buyOrderDownloadCSVText, buyOrderDownloadPDFTemplateText, buyOrderDownloadPDFText, buyOrderDownloadTagsText, buyOrderDuplicateText, buyOrderPreviewPDFText, data, onSubmit, isReadOnly, showButtonByPricesPermission, buyOrderProductTypesText, buyOrderPreviewSupplierPDFText])

    return { name, ButtonComponents, defaultButtons }
}

export const BuyOrderCreateNoPermissionButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useBuyOrderCreateNoPermissionButtonsLogic, ...rest }} className='mr-8' />
    )
}

export default BuyOrderCreateNoPermissionButtons